<template>
  <v-container id="genericReport" fluid>
    <header
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      "
    >
      <div
        style="
          border-bottom: 1px solid #aaa;
          width: 100%;
          text-align: center;
          margin-bottom: 10px;
        "
      >
        <Footer />
      </div>
      <img
        :src="
          prefecture.prefecture_logo
            ? $store.state.urlImages + prefecture.prefecture_logo
            : require('@/assets/no-image.jpg')
        "
        :alt="prefecture.social_name ? prefecture.social_name : ''"
        style="width: 250px; padding: 20px"
      />
      <h1 style="font-weight: 400">
        {{
          prefecture.prefecture_social_name
            ? prefecture.prefecture_social_name
            : ""
        }}
      </h1>
      <h4>
        Período de: {{ convertDate(filter.startDate) }} até
        {{ convertDate(filter.endDate) }}
      </h4>
    </header>
    <br />
    <br />
    <div v-if="data.result">
      <div v-for="(res, index) in data.result" :key="index">
        <table
          class="table"
          style="
            border-collapse: collapse;
            border: 1px solid rgb(214, 214, 214);
            border-top: 0;
            text-align: center;
            width: 100%;
          "
        >
          <thead>
            <tr
              style="border: 1px solid rgb(214, 214, 214); text-align: center"
            >
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                SUB-SETOR
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                VEÍCULO
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                MODELO
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                TANQUE
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                PLACA
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ res.vehicle.subsec_id ? res.vehicle.subsec_id : "---" }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ res.vehicle.brand_desc }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ res.vehicle.model_desc }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{
                  res.vehicle.vehicle_tank_capacity
                    ? res.vehicle.vehicle_tank_capacity.toFixed(2)
                    : ""
                }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ res.vehicle.vehicle_board }}
              </td>
            </tr>
          </tbody>
        </table>
        <table
          style="
            border-collapse: collapse;
            border: 1px solid rgb(214, 214, 214);
            border-top: 0;
            text-align: center;
          "
        >
          <thead
            style="border: 1px solid rgb(214, 214, 214); text-align: center"
          >
            <tr>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                POSTO
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                COMBUSTÍVEL
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                DATA
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                PREÇO DIA
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                PREÇO LICITADO
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                LITROS ABASTECIDOS
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                VALOR TOTAL
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                VALOR TOTAL LICITAÇÃO
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                KM ANTERIOR
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                KM ATUAL
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                KM RODADOS
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                MÉDIA (KM/L)
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                FATURADO
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                CUPOM/NFE
              </th>
            </tr>
          </thead>
          <tbody v-for="(supply, sindex) in res.dataSupplies" :key="sindex">
            <tr>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ supply.provider_name }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ supply.item_description_desc }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ convertDateTime(supply.datehour) }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{
                  supply.supply_price_day
                    ? realMask(supply.supply_price_day.toFixed(2))
                    : ""
                }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{
                  supply.item_billing_price
                    ? realMask(supply.item_billing_price.toFixed(2))
                    : ""
                }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{
                  supply.supply_liters_stocked
                    ? realMaskII(supply.supply_liters_stocked.toFixed(3))
                    : ""
                }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{
                  supply.supply_value
                    ? realMask(supply.supply_value.toFixed(2))
                    : ""
                }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{
                  supply.supply_bidding_value
                    ? realMask(supply.supply_bidding_value.toFixed(2))
                    : ""
                }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ supply.lastKm }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ supply.supply_km }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ supply.traveled ? supply.traveled.toFixed(0) : 0 }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ supply.average ? realMask(supply.average.toFixed(2)) : 0 }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ !supply.supply_billed ? "NÃO" : "SIM" }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ supply.supply_coupon }}
              </td>
            </tr>
          </tbody>
        </table>
        <table
          style="
            border-collapse: collapse;
            border: 1px solid rgb(214, 214, 214);
            border-top: 0;
            text-align: center;
            width: 100%;
          "
        >
          <thead>
            <tr>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                KM RODADOS
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                TOTAL DE LITROS
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                VALOR PAGO
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                MEDIA CONSUMO
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {{
                  res.totals.totalKm
                    ? convertDecimalValue(res.totals.totalKm.toFixed(0))
                    : 0
                }}
              </td>
              <td>
                {{
                  res.totals.totalLiters
                    ? convertDecimalValue(res.totals.totalLiters)
                    : 0
                }}
              </td>
              <td>
                {{
                  res.totals.totalValue
                    ? convertDecimalValue(res.totals.totalValue)
                    : 0
                }}
              </td>
              <td>
                {{
                  res.totals.averageTotal
                    ? realMask(res.totals.averageTotal.toFixed(2))
                    : 0
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-for="(total, itotal) in res.finalTotals"
          :key="itotal"
          style="
            border-collapse: collapse;
            border: 1px solid rgb(214, 214, 214);
            border-top: 0;
            text-align: center;
            width: 100%;
          "
        >
          <thead>
            <tr>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                TIPO DE COMBUSTÍVEL
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                LITROS
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                VALOR
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ total.item_description_desc }}</td>
              <td>
                {{
                  total.totalLiters ? convertDecimalValue(total.totalLiters) : 0
                }}
              </td>
              <td>
                {{
                  total.totalValues ? convertDecimalValue(total.totalValues) : 0
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <table
          style="
            border-collapse: collapse;
            border: 1px solid rgb(214, 214, 214);
            border-top: 0;
            text-align: center;
            width: 100%;
          "
        >
          <thead>
            <tr>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                RESUMO FINAL
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                TOTAL DE LITROS
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                VALOR TOTAL
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td>
                {{
                  res.resume.liters ? convertDecimalValue(res.resume.liters) : 0
                }}
              </td>
              <td>
                {{
                  res.resume.value ? convertDecimalValue(res.resume.value) : 0
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else>
      <div v-for="(res, index) in data.response" :key="index">
        <table
          class="table"
          style="
            border-collapse: collapse;
            border: 1px solid rgb(214, 214, 214);
            border-top: 0;
            text-align: center;
            width: 100%;
          "
        >
          <thead>
            <tr
              style="border: 1px solid rgb(214, 214, 214); text-align: center"
            >
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                SUB-SETOR
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                VEÍCULO
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                MODELO
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                TANQUE
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                PLACA
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ res.vehicle.sec_name ? res.vehicle.sec_name : "---" }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ res.vehicle.brand_desc }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ res.vehicle.model_desc }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{
                  res.vehicle.vehicle_tank_capacity
                    ? res.vehicle.vehicle_tank_capacity.toFixed(2)
                    : 0
                }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ res.vehicle.vehicle_board }}
              </td>
            </tr>
          </tbody>
        </table>
        <table
          style="
            border-collapse: collapse;
            border: 1px solid rgb(214, 214, 214);
            border-top: 0;
            text-align: center;
          "
        >
          <thead
            style="border: 1px solid rgb(214, 214, 214); text-align: center"
          >
            <tr>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                POSTO
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                COMBUSTÍVEL
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                DATA
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                PREÇO DIA
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                PREÇO LICITADO
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                LITROS ABASTECIDOS
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                VALOR TOTAL
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                VALOR TOTAL LICITAÇÃO
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                KM ANTERIOR
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                KM ATUAL
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                KM RODADOS
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                MÉDIA (KM/L)
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                FATURADO
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                CUPOM/NFE
              </th>
            </tr>
          </thead>
          <tbody v-for="(supply, sindex) in res.dataSupplies" :key="sindex">
            <tr>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ supply.provider_name }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ supply.item_description_desc }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ convertDateTime(supply.datehour) }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{
                  supply.supply_price_day
                    ? realMask(supply.supply_price_day.toFixed(2))
                    : 0
                }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{
                  supply.supply_bidding_price
                    ? realMask(supply.supply_bidding_price.toFixed(2))
                    : 0
                }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{
                  supply.supply_liters_stocked
                    ? realMaskII(supply.supply_liters_stocked.toFixed(3))
                    : 0
                }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{
                  supply.supply_value
                    ? realMask(supply.supply_value.toFixed(2))
                    : 0
                }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{
                  supply.supply_bidding_value
                    ? realMask(
                        parseFloat(
                          supply.supply_bidding_value.toFixed(3)
                        ).toFixed(2)
                      )
                    : 0
                }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ supply.lastKm }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ supply.supply_km }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ supply.traveled ? supply.traveled.toFixed(0) : 0 }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ supply.average ? realMask(supply.average.toFixed(2)) : 0 }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ !supply.supply_billed ? "NÃO" : "SIM" }}
              </td>
              <td
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 8px;
                  text-align: center;
                "
              >
                {{ supply.supply_coupon }}
              </td>
            </tr>
          </tbody>
        </table>
        <table
          style="
            border-collapse: collapse;
            border: 1px solid rgb(214, 214, 214);
            border-top: 0;
            text-align: center;
            width: 100%;
          "
        >
          <thead>
            <tr>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                KM RODADOS
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                TOTAL DE LITROS
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                VALOR PAGO
              </th>
              <th
                style="
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                MEDIA CONSUMO
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {{
                  res.totals.totalKm
                    ? convertDecimalValue(res.totals.totalKm)
                    : 0
                }}
              </td>
              <td>
                {{
                  res.totals.totalLiters
                    ? convertDecimalValue(res.totals.totalLiters)
                    : 0
                }}
              </td>
              <td>
                {{
                  res.totals.totalValue
                    ? convertDecimalValue(res.totals.totalValue)
                    : 0
                }}
              </td>
              <td>
                {{
                  res.totals.averageTotal
                    ? res.totals.averageTotal.toFixed(2)
                    : 0
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <br /><br />
      </div>
      <table
        v-for="(total, itotal) in data.finalTotals"
        :key="itotal"
        style="
          border-collapse: collapse;
          border: 1px solid rgb(214, 214, 214);
          border-top: 0;
          text-align: center;
          width: 100%;
        "
      >
        <thead>
          <tr>
            <th
              style="
                border: 1px solid rgb(214, 214, 214);
                padding: 5px;
                text-align: center;
                background: gray;
                color: #fff;
              "
            >
              TIPO DE COMBUSTÍVEL
            </th>
            <th
              style="
                border: 1px solid rgb(214, 214, 214);
                padding: 5px;
                text-align: center;
                background: gray;
                color: #fff;
              "
            >
              LITROS
            </th>
            <th
              style="
                border: 1px solid rgb(214, 214, 214);
                padding: 5px;
                text-align: center;
                background: gray;
                color: #fff;
              "
            >
              VALOR
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ total.item_description_desc }}</td>
            <td>
              {{
                total.totalLiters ? convertDecimalValue(total.totalLiters) : 0
              }}
            </td>
            <td>
              {{ total.totalValue ? convertDecimalValue(total.totalValue) : 0 }}
            </td>
          </tr>
        </tbody>
      </table>
      <table
        style="
          border-collapse: collapse;
          border: 1px solid rgb(214, 214, 214);
          border-top: 0;
          text-align: center;
          width: 100%;
        "
      >
        <thead>
          <tr>
            <th
              style="
                border: 1px solid rgb(214, 214, 214);
                padding: 5px;
                text-align: center;
                background: gray;
                color: #fff;
              "
            >
              ITEM
            </th>
            <th
              style="
                border: 1px solid rgb(214, 214, 214);
                padding: 5px;
                text-align: center;
                background: gray;
                color: #fff;
              "
            >
              TOTAL DE LITROS
            </th>
            <th
              style="
                border: 1px solid rgb(214, 214, 214);
                padding: 5px;
                text-align: center;
                background: gray;
                color: #fff;
              "
            >
              VALOR TOTAL
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(tResume, tr) in data.finalResume" :key="tr">
            <td
              style="
                border: 1px solid rgb(214, 214, 214);
                padding: 8px;
                text-align: center;
              "
            >
              {{ tResume.item_description_desc }}
            </td>
            <td
              style="
                border: 1px solid rgb(214, 214, 214);
                padding: 8px;
                text-align: center;
              "
            >
              {{ convertDecimalValue(tResume.totalLiters) }}
            </td>
            <td
              style="
                border: 1px solid rgb(214, 214, 214);
                padding: 8px;
                text-align: center;
              "
            >
              {{ convertDecimalValue(tResume.totalValues) }}
            </td>
          </tr>
        </tbody>
      </table>
      <table
        style="
          border-collapse: collapse;
          border: 1px solid rgb(214, 214, 214);
          border-top: 0;
          text-align: center;
          width: 100%;
        "
      >
        <thead>
          <tr>
            <th
              style="
                border: 1px solid rgb(214, 214, 214);
                padding: 5px;
                text-align: center;
                background: gray;
                color: #fff;
              "
            >
              RESUMO FINAL
            </th>
            <th
              style="
                border: 1px solid rgb(214, 214, 214);
                padding: 5px;
                text-align: center;
                background: gray;
                color: #fff;
              "
            >
              TOTAL DE LITROS
            </th>
            <th
              style="
                border: 1px solid rgb(214, 214, 214);
                padding: 5px;
                text-align: center;
                background: gray;
                color: #fff;
              "
            >
              VALOR TOTAL
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td
              style="
                border: 1px solid rgb(214, 214, 214);
                padding: 8px;
                text-align: center;
              "
            >
              {{ convertDecimalValue(data.finalTotalResume.totalLiters) }}
            </td>
            <td
              style="
                border: 1px solid rgb(214, 214, 214);
                padding: 8px;
                text-align: center;
              "
            >
              {{ convertDecimalValue(data.finalTotalResume.totalValue) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import helpers from "@/mixins/helpers";
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Footer,
  },
  props: ["data", "filter", "prefecture"],
  mixins: [helpers],
  methods: {
    initialize() {
      this.helpers;
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  border: 1px solid rgb(17, 17, 17);
}
</style>